import React from 'react'

export default function Unfinished(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 47.7 44"
      width="32"
      height="32"
      {...props}
    >
      <path d="M0 22c0 12.1 9.9 22 22 22 3.2 0 6.4-.7 9.3-2 1.2-.6 1.7-2 1.2-3.2-.4-.9-1.3-1.4-2.2-1.4-.4 0-.7.1-1 .2-2.3 1.1-4.7 1.6-7.2 1.6C12.7 39.2 5 31.5 5 22.1 5 12.7 12.7 5 22.1 5c9.4 0 17.1 7.6 17.1 17.1 0 .8-.3.9-.9.9h-2c-.4 0-.7.1-.8.4-.2.4.1.8.2.9l5.3 8.3c.2.3.4.3.6.3.2 0 .4-.1.5-.3l5.3-8.4c.1-.1.4-.5.2-.9-.1-.2-.4-.4-.7-.4h-2c-.6 0-.9-.2-.9-.7V22C44 9.8 34.1 0 22 0S0 9.9 0 22z" />
      <path d="M20.8 13.3v8l-7 4.5c-.9.6-1.2 1.8-.6 2.8.4.6 1 .9 1.7.9.4 0 .7-.1 1.1-.3l7.3-4.7c.9-.6 1.5-1.7 1.5-2.7v-8.4c0-1.1-.9-2-2-2-1.1-.1-2 .8-2 1.9z" />
    </svg>
  )
}
